import React from 'react';
import styled from 'styled-components';
import { theme, Icon } from '../../../../../ui';

const IconBase = styled.div`
  min-width: 18px;
  height: 18px;
  margin-right: 10px;
  border-radius: 50%;
  background: ${({ $color }) => $color || theme.colors.PRIMARY};
`;

const IconLocked = styled.div`
  min-width: 18px;
  height: 18px;
  margin-right: 10px;
  background: transparent;
`;

const IconQuiz = styled.div`
  margin: 6px 6px 0 -3px;
`;

const IconDiploma = styled.div`
  margin: 6px 6px 0 -3px;
`;

const IconViewed = styled(IconBase)`
  background: ${({ $darkColor, $lightColor }) =>
    `linear-gradient(0deg, ${$darkColor || theme.colors.PRIMARY} 50%, ${$lightColor || theme.colors.PRIMARY_LIGHT} 50%)`};
`;

const IconReady = styled(IconBase)`
  position: relative;

  &::before {
    width: 6px;
    height: 3px;
    content: '';
    border-bottom: 2px solid ${({ $detailsColor }) => $detailsColor || theme.colors.PRIMARY};
    border-left: 2px solid ${({ $detailsColor }) => $detailsColor || theme.colors.PRIMARY};
    position: absolute;
    left: 29%;
    top: 33%;
    transform: rotate(-50deg);
  }
`;

/**
 * SectionIcon - Renders the appropriate icon for a section based on its type and progress
 */
const SectionIcon = ({ section, isLocked, darkColor, userColor }) => {
  if (section.type === 'quiz') {
    return (
      <IconQuiz>
        <Icon.Questions size='medium' color={darkColor} />
      </IconQuiz>
    );
  }

  if (section.type === 'diploma') {
    return (
      <IconDiploma>
        <Icon.Certificate size='medium' color={userColor} />
      </IconDiploma>
    );
  }

  if (isLocked) {
    return <IconLocked />;
  }

  if (section.progress === 1) {
    return <IconReady $color={userColor} $detailsColor={darkColor} />;
  }

  if (section.progress > 0) {
    return <IconViewed $lightColor={userColor} $darkColor={darkColor} />;
  }

  return <IconBase $color={darkColor} />;
};

export default SectionIcon;
